// extracted by mini-css-extract-plugin
export default {"icon":"ClientsImportCollision--icon--17c6db","container":"ClientsImportCollision--container--f61280"};